import styled from "styled-components"
import { colors } from "../../lib/colors"
import { FOOTER_STYLE_PROPS } from "./interface"
import { widthChange } from "../../animations/Interactions"

export const FooterRow = styled.div<FOOTER_STYLE_PROPS>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
  position: relative;
  ${({ fadeOut }) => (fadeOut ? "position: absolute; opacity: 0;" : "")};
  transition: 0.3s linear;
  transition-property: opacity;
  /* &&.upFloor {
    .disabled {
      pointer-events: none !important;
      background: green !important;
    }
  } */
`

export const StakeButton = styled.div<FOOTER_STYLE_PROPS>`
  border: solid 3px ${colors.secondary};
  color: ${colors.secondary};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 38px;
  height: 56px;
  width: 100%;
  max-width: 184px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  svg {
    margin-left: 4px;
    path {
      fill: ${colors.secondary};
    }
  }
  &&.disabled {
    pointer-events: none;
  }
  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;
    transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
    transition: transform 0.167s;
    ${(p) => (p.anim ? "opacity: 0.5;" : "")}
  }
`
export const GamePlayButton = styled.div<FOOTER_STYLE_PROPS>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 38px;
  color: ${colors.secondaryText};
  background: ${colors.secondary};
  font-size: 20px;
  height: 56px;
  width: 100%;
  transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
  transition: transform 0.16s;
  ${(p) => (p.anim ? "transform: scale(0.65);" : "transform: scale(1); ")}
  text-transform: uppercase;
  ${({ fadeOut }) => fadeOut && widthChange};
  cursor: pointer;
  pointer-events: ${({ isClickable }) => (isClickable ? "auto" : "none")};
  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;
    transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
    transition: transform 0.16s;
    ${(p) => (p.anim ? "opacity: 0.5;" : "")}
  }
  span {
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    text-transform: none;
  }
  svg {
    height: 10px;
    margin-left: 1px;
    path {
      fill: ${colors.secondaryText};
    }
  }
`
export const AnimatedText = styled.p<FOOTER_STYLE_PROPS>`
  position: absolute;
  width: 100%;
  text-transform: uppercase;
  text-align: center;
  pointer-events: none;
  opacity: ${({ fadeOut }) => (fadeOut ? 0 : 1)};
  transition: transform 0.16s;
  z-index: 1;
  line-height: 1;
  font-size: 20px;
  color: ${colors.secondaryText};
  transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
  ${(p) =>
    p.anim
      ? "transform: scale(0.65); pointer-events: none"
      : "transform: scale(1); "}
`
